<template>
  <div class="rs-pagination-bar">
    <RsPagination
      :value="value"
      @input="(e) => $emit('input', e)"
    />
    <div class="pagination-info">
      <BFormSelect
        v-if="showOptionValues"
        :value="value.recordsPerPage"
        @change="(e) => $emit('input', { ...value, ...{ recordsPerPage: parseInt(e, 10), currentPage: 1 } })"
      >
        <option value="20">
          20
        </option>
        <option value="40">
          40
        </option>
        <option value="80">
          80
        </option>
      </BFormSelect>
      <span>{{ $ts('pagination.showing') }} {{ value.currentRange }} {{ $ts('pagination.of') }} {{ value.totalRecords }}</span>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { IPageRange } from '@/shared';

export default defineComponent({
  name: 'RsPaginationBar',

  props: {
    showOptionValues: {
      type: Boolean,
      default: true,
    },
    value: {
      type: Object as () => IPageRange,
      default: () => ({
        recordsPerPage: 20,
        totalPages: 0,
        currentPage: 1,
        currentRange: '1 - 20',
        totalRecords: 0,
      } as IPageRange),
    },
  },
});
</script>

<style lang="scss">
@import '@/styles/_variables.scss';
$gray: #8694B3;
.rs-pagination-bar{
  margin-top: 2rem;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  .pagination-info{
    display: flex;
    justify-content: space-between;
    align-items: center;
    span{
      margin-left: 0.5rem;
      font-size: 0.875rem;
      color: $tertiary-muted;
    }
    .custom-select{
      padding: 0rem 1.75rem 0rem 0.5rem;
      width: auto;
      height: 32px;
      background-color: rgba($gray, 0.1);
      border: none;
      color: $gray;
      cursor: pointer;
      &:focus{
        box-shadow: none;
      }
      option{
        cursor: pointer;
      }
    }
  }
}
</style>
